import React from "react";
import { Typography, Box, Stack, Menu, MenuItem, Button, IconButton } from "@mui/material";
import { RiDoubleQuotesL, RiDoubleQuotesR } from "react-icons/ri";
import colorsCustom from "../designTokens/colorsCustom";
import { WriterInfo } from "./WriterInfo/WriterInfo";
import { useTranslation } from "react-i18next";
import { IconDotsVertical } from "@tabler/icons-react";
import { IconPencil, IconTrash } from "@tabler/icons-react";
import { ButtonBasic } from "./button/ButtonBasic";
import layout from "../designTokens/layout";
import TypingEffect from "./patterns/typoraphy/TypingEffect";

const CollectionTitleSection = ({
  collection,
  isMobile,
  setModalOpen,
  handleDeleteCollection,
  isMe,
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box sx={{ 
      width: "100%", 
      display: "flex", 
      justifyContent: "flex-start",
      padding: isMobile ? "0" : "0 24px 0 0" // 우측 패딩으로 변경
    }}>
      <Stack 
        spacing={isMobile ? 4 : 6} 
        sx={{ 
          width: isMobile ? layout.content.maxWidth.mobile : layout.content.maxWidth.desktop,
          maxWidth: "100%",
          alignItems: "flex-start" 
        }}
      >
      {/* 타이틀과 작성자 정보를 하나의 Stack으로 묶음 */}
      <Stack spacing={isMobile ? 1.5 : 2} sx={{ width: '100%' }}>
        <TypingEffect
          texts={[collection.title]}
          textColor={colorsCustom.ui.dark.bold}
          cursorColor={colorsCustom.ui.dark.bold}
          cursorType="circle"
          typingSpeed={60}
          deleteSpeed={30}
          variant={{ xs: "h5", sm: "h5", md: "h4", lg: "h4" }}
          textAlign="left"
          fontWeight={800}
          fontFamily='"source-han-serif-korean", "Noto Serif KR", "Noto Serif CJK KR", "Source Han Serif KR", "Apple SD Gothic Neo", "Malgun 고딕", "맑은 고딕", serif'
          sx={{ width: "100%" }}
        />

        {/* 작성자 정보 */}
        {isMe ? (
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <WriterInfo
              profileImage={collection.profileImage}
              userID={collection.userID}
              username={collection.username}
              name={collection.name}
              size={isMobile ? "big" : "huge"}
              enableDynamicAvatar={true}
              showThreadsLink={true}
            />
            <ButtonBasic
              actionType="secondary"
              variant="outlined"
              size={isMobile ? "md" : "lg"}
              leftSection={<IconDotsVertical size={20} />}
              onClick={handleClick}
            >
              {t("myCollection.modify")}
            </ButtonBasic>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
              <MenuItem onClick={() => { setModalOpen(true); handleClose(); }}>
                <IconPencil style={{ marginRight: 8 }} />
                {t("myCollection.modify")}
              </MenuItem>
              <MenuItem onClick={() => { handleDeleteCollection(); handleClose(); }}>
                <IconTrash style={{ marginRight: 8 }} />
                {t("myCollection.delete")}
              </MenuItem>
            </Menu>
          </Box>
        ) : (
          <WriterInfo
            profileImage={collection.profileImage}
            userID={collection.userID}
            username={collection.username}
            name={collection.name}
            size={isMobile ? "big" : "huge"}
            enableDynamicAvatar={true}
            showUserPageLink={true}
          />
        )}
      </Stack>

      {/* 설명을 작성자 정보 아래로 이동 */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 0.45,
          position: "relative",
          width: "fit-content",
          maxWidth: "100%",
          mt: isMobile ? 4 : 6
        }}
      >
        <Typography
          variant={isMobile ? "body1" : "body1"}
          sx={{
            fontWeight: 300,
            textAlign: "left",
            color: colorsCustom.ui.dark.bold,
            // wordBreak: "keep-all",
            // whiteSpace: "pre-wrap"
          }}
        >
          {collection.description}
        </Typography>
      </Box>
      </Stack>
    </Box>
  );
};

export default CollectionTitleSection;
